<template>
    <div>
        <v-dialog scrollable content-class="item-translation-languages-dialog" :persistent="isDialogPersistent" v-model="dialog">
            <item-translation-languages/>
        </v-dialog>
    </div>
</template>

<script>
import DialogSettings from "../../mixins/dialogSettings";

export default {
    name: "NoTranslation",

    mixins: [DialogSettings],

    data: function () {
        return {
            dialog: true,
        }
    },
}
</script>